import { getJobIdsByExecuteId, getParams } from '../reducers/analyticsApp';
import authFetch from './authFetch';

// Идентичность несёт HttpOnly cookie JWT (OIDC), поэтому заголовок Authorization не нужен —
// важно лишь credentials: 'include', чтобы cookie уходила со всеми запросами.
export const fetchJsonByUrlEncodedPost = (path, body, { backendUrl, tenantId }) =>
  authFetch(`${backendUrl}${path}`, {
    method: 'POST',
    headers: {
      tenantId,
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    credentials: 'include',
    body,
  }).then((response) => response.json());

export const fetchJsonByPost = (path, body, { backendUrl, tenantId }) =>
  authFetch(`${backendUrl}${path}`, {
    method: 'POST',
    headers: {
      tenantId,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  }).then((response) => response.json());

export const fetchJsonByPut = (path, body, { backendUrl, tenantId }) =>
  authFetch(`${backendUrl}${path}`, {
    method: 'PUT',
    headers: {
      tenantId,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  }).then((response) => response.json());

export const fetchTextByPost = (path, body, { backendUrl, tenantId }) =>
  authFetch(`${backendUrl}${path}`, {
    method: 'POST',
    headers: {
      tenantId,
      Accept: 'text/plain',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  }).then((response) => response.text());

export const fetchJsonByGet = (path, { backendUrl, tenantId }) =>
  authFetch(`${backendUrl}${path}`, {
    method: 'GET',
    headers: {
      tenantId,
      Accept: 'application/json',
    },
    credentials: 'include',
  }).then((response) => response.json());

export const fetchJsonByDelete = (path, { backendUrl, tenantId }) =>
  authFetch(`${backendUrl}${path}`, {
    method: 'DELETE',
    headers: {
      tenantId,
      Accept: 'application/json',
    },
    credentials: 'include',
  }).then((response) => response.json());

export const noResponseDelete = (path, { backendUrl, tenantId }) =>
  authFetch(`${backendUrl}${path}`, {
    method: 'DELETE',
    headers: {
      tenantId,
    },
    credentials: 'include',
  });

export const noResponseYamlPut = (path, body, { backendUrl, tenantId }) =>
  authFetch(`${backendUrl}${path}`, {
    method: 'PUT',
    headers: {
      tenantId,
      'Content-Type': 'application/x-yaml',
    },
    credentials: 'include',
    body,
  });

export const fetchYamlByGet = (path, { backendUrl, tenantId }) =>
  authFetch(`${backendUrl}${path}`, {
    method: 'GET',
    headers: {
      tenantId,
      Accept: 'application/x-yaml',
    },
    credentials: 'include',
  }).then((response) => response.text());

const runEventQuery = (query, params) => fetchJsonByPost('/events/query', query, params);

const runExposeEvent = (query, params) => fetchTextByPost('/events/query/expose', query, params);

const executeJob = (jobId, params) => fetchJsonByGet(`/query?id=${jobId}`, params);

const cancelJob = (jobId, params) =>
  // квери параметр для фикса TOOLS-3930, чтобы отличался эндпоинт для GET и DELETE запросов. Баг не воспроизводится для
  // Chrome в системе Arch Linux, но пока воспроизводится в Chrome/Windows и Chromium/Arch. Возможно с будущим обновлением пофиксится
  noResponseDelete(`/query?id=${jobId}&cancel=true`, params);

const dispatchQueryIds = (executeId, ids, dispatch) => {
  dispatch({
    type: `SET_QUERY_IDS`,
    executeId,
    ids,
  });
};

export const dispatchRequestInfo = (executeId, dispatch, type, events, isCSV) => {
  dispatch({
    type: `SET_REQUEST_INFO`,
    executeId,
    appType: type,
    events,
    isCSV,
  });
};

const deleteRequestId = (executeId, dispatch) => {
  dispatch({
    type: `DELETE_QUERY_IDS`,
    executeId,
  });
};

const dispatchQueryId = (executeId, id, dispatch) => dispatchQueryIds(executeId, [id], dispatch);

export const executeTwoStepQueries = (apiFn, queries, executeId, dispatch, getState) => {
  const params = getParams(getState());
  return Promise.all(queries.map((query) => apiFn(query, params))).then((response) => {
    const ids = response.map(({ jobId }) => jobId);
    dispatchQueryIds(executeId, ids, dispatch);
    return Promise.all(ids.map((id) => executeJob(id, params))).finally(() =>
      deleteRequestId(executeId, dispatch)
    );
  });
};

export const executeTwoStepQuery = (apiFn, query, executeId, dispatch, getState) => {
  const params = getParams(getState());
  return apiFn(query, params).then(({ jobId }) => {
    dispatchQueryId(executeId, jobId, dispatch);
    return executeJob(jobId, params).finally(() => deleteRequestId(executeId, dispatch));
  });
};

export const cancelRequest = (executeId) => (dispatch, getState) => {
  const state = getState();
  const params = getParams(state);
  const ids = getJobIdsByExecuteId(state, executeId);
  return Promise.all(ids.map((id) => cancelJob(id, params)));
};

export const executeQuery = (apiFn, query, executeId, dispatch, getState) =>
  apiFn(query, getParams(getState()));

export const executeTwoStepEventQueries = (queries, executeId, dispatch, getState) =>
  executeTwoStepQueries(runEventQuery, queries, executeId, dispatch, getState);

export const executeTwoStepEventQuery = (query, executeId, dispatch, getState) =>
  executeTwoStepQuery(runEventQuery, query, executeId, dispatch, getState);

export const exposeEvent = (query, executeId, dispatch, getState) =>
  executeQuery(runExposeEvent, query, executeId, dispatch, getState);
